import {AbstractLitInputComponent} from "../../abstract-lit-input.component";
import {WeeklyWorkingTime} from "../../../domain/entities/weekly-working-time.entity";
import {customElement} from "lit/decorators/custom-element.js";
import {html, PropertyValues} from "lit";
import {when} from "lit/directives/when.js";
import {UuidHelper} from "../../../helpers/uuid.helper";
import {translate} from "lit-translate";
import {WeekDayName} from "../../../enums/week-day-name.enum";
import {repeat} from "lit/directives/repeat.js";
import {state} from "lit/decorators/state.js";

@customElement(`ha-input-weekly-working-time`)
export class HaInputWeeklyWorkingTimeComponent extends AbstractLitInputComponent<Promise<WeeklyWorkingTime>> {

    private _id: string = UuidHelper.generateV7();

    @state()
    private _weeklyWorkingTime: WeeklyWorkingTime | null = null;

    public render(): unknown {

        if (!this._weeklyWorkingTime) {
            return html`
                <div class="loading-badge"></div>
            `;
        }

        return html`
            ${when(!!this.label, () => html`
                <label for=${this._id}>${this.label}</label>
            `)}
            <div class="week">
                ${repeat(Object.values(WeekDayName) as WeekDayName[], w => w, weekDayName => {
                    return html`
                        <ha-input-number data-type=${weekDayName}
                                         postfix="h"
                                         class="day"
                                         label=${translate(`components.ha-input-weekly-working-time.labels.${weekDayName}`)}
                                         .value=${this._weeklyWorkingTime?.getByName(weekDayName)}
                                         @value-changed=${(evt: CustomEvent<{ value: number }>) => this._onWorkingTimeChanged(weekDayName, evt.detail.value)}
                        ></ha-input-number>
                    `;
                })}
            </div>
            ${this._renderHelperText()}
            ${this._renderErrors()}
        `;
    }

    protected willUpdate(changedProperties: PropertyValues) {
        if (changedProperties.has('value') && !!this.value) {
            this.value.then(weeklyWorkingTime => this._weeklyWorkingTime = weeklyWorkingTime)
        }
    }

    private _onWorkingTimeChanged(dayName: WeekDayName, time: number): void {
        this._weeklyWorkingTime?.setByName(dayName, time);
        // Non-null: this handler is only bound to the day inputs, which render() creates only
        // after its early return for a null `_weeklyWorkingTime`.
        this.value = Promise.resolve(this._weeklyWorkingTime!);
        this.fire<Promise<WeeklyWorkingTime>>(this.value);
    }

}